import React, { Component } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../../config';
import Chains from '../detail-components/filters/chains';
import Turnover from '../detail-components/filters/turnover';
import Size from '../detail-components/filters/size';
import SaveButton from '../../report/save-button';
import withAuthProvider from '../../../hoc/withAuthProvider';
import withFetch from '../../../hoc/withFetch';
import { Select } from '../../forms';
import SpinnerDots from '../../spinner/dots';
import './create-classification-form.scss';

class CreateClassificationForm extends Component {

    registeredComponents = [];
    state = {
        isLoading: true,
        isSaving: false,
        classification: null,
        units:[]
    };

    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.classification) return;

        const unitRes = await this.props.fetch(`${REACT_APP_API_BASE}/salesdistrict/units/livs`);
        const units = await unitRes.json();
        const { match } = this.props;
        const id = this.props.classificationId || match.params.id;
        const scenarioId = this.props.scenarioId || (match.params.scenarioId ? match.params.scenarioId : '');
        const isEdit = this.props.isEdit !== undefined ? this.props.isEdit : id;
        
        const path = isEdit ? `${REACT_APP_API_BASE}/salesdistrict/classification/edit/${id}` : `${REACT_APP_API_BASE}/salesdistrict/classification/create/${scenarioId}`
        const res = await this.props.fetch(path);
        const classification = await res.json();

        this.setState({
            classification,
            isLoading: false,
            units
        });
    }

    async save(e) {
        e.preventDefault();

        this.setState({
            isLoading: true,
            isSaving: true
        });

        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        const { match } = this.props;
        const id = this.props.classificationId || match.params.id;
        const isEdit = this.props.isEdit !== undefined ? this.props.isEdit : id;

        const path = isEdit ? `${REACT_APP_API_BASE}/salesdistrict/classification/edit/${id}` : `${REACT_APP_API_BASE}/salesdistrict/classification/create/`;

        const rawResponse = await fetch(path, {
            method: isEdit ? 'PATCH' : 'POST',
            headers: headers,
            body: JSON.stringify({
                ...this.state.classification
            })
        });

        if (rawResponse.ok) {
            await rawResponse.json();

            this.setState({
                isSaved: true,
                isSaving: false,
                isLoading: false
            }, () => {
                setTimeout(() => {
                    if (this.props.saveSuccessCallback) {
                        this.props.saveSuccessCallback();
                        this.setState({
                            isSaved: false,
                            isSaving: false,
                            isLoading: false
                        });
                    } else {
                        window.location.href = `/scenario/${match.params.scenarioId}`;
                    }
                }, 1000);
            });            
        } else {
        }
    }

    handleUpdate(key, value) {
        const classification = { ...this.state.classification };
        classification[key] = value;

        this.setState({
            classification
        });
    }

    registerComponent(comp) {
        this.registeredComponents.push(comp);
    }

    updateValues() {
        const classification = { ...this.state.classification };

        this.registeredComponents.forEach(comp => {
            classification[comp.getPropertyName()] = comp.getValues();
        });

        this.setState({
            classification
        });
    }

    handleChangeSelectBox(list, key, value) {
        const classification = { ...this.state.classification };

        classification[list].forEach(item => {
            item.selected = false;
            if (item[key] === value) {
                item.selected = true;
            }
        });

        this.setState({
            classification
        });
    }

    getDefaultSelected(list, key) {
        const selected = list.filter(freq => freq.selected);
        
        if (selected && selected[0]) {
            return selected[0][key]
        }

        return list;
    }

    render() {

        const { classification } = this.state;
        const { match } = this.props;

        return (
            <div className={classNames({
                'classification-form': true,
                'classification-form--is-loading': this.state.isLoading
            })}>
                <div className="classification-form__content-wrapper">
                    {classification &&
                        <form onSubmit={(e) => this.save(e)}>
                            <div className="classification-form__content">
                                <fieldset className="classification-form__fieldset">
                                    <label className="classification-form__label" htmlFor="name">Namn</label>
                                    <input id="name" className="classification-form__input-text" type="text" value={classification.name} onChange={(e) => this.handleUpdate('name', e.currentTarget.value)} />
                                </fieldset>
                                <fieldset className="classification-form__fieldset">
                                    <h2 className="classification-form__fieldset-heading">1. Välj kedja</h2>
                                    <Chains filters={classification} 
                                            registerFilter={(comp) => this.registerComponent(comp)} 
                                            previewFilter={() => this.updateValues()} 
                                            propertyName="chains" />
                                </fieldset>
                                <fieldset className="classification-form__fieldset">
                                    <h2 className="classification-form__fieldset-heading">2. Välj omsättning & säljyta</h2>
                                    <Turnover filters={classification} 
                                            registerFilter={(comp) => this.registerComponent(comp)} 
                                            previewFilter={() => this.updateValues()} 
                                            units={this.state.units} 
                                            propertyName="turnovers" 
                                            modifiers={{
                                                'slider--big': true,
                                                'slider--gray': true
                                            }} 
                                            caption={<>Omsättning <span className="classification-form__caption-light">(KKR/år)</span></>} />
                                    <Size filters={classification} 
                                        registerFilter={(comp) => this.registerComponent(comp)} 
                                        previewFilter={() => this.updateValues()} 
                                        units={this.state.units} 
                                        propertyName="salesSpaceGroups" 
                                        modifiers={{
                                            'slider--big': true,
                                            'slider--gray': true
                                        }}
                                        caption={<>Säljyta <span className="classification-form__caption-light">(m2)</span></>} />
                                </fieldset>
                                <fieldset className="classification-form__fieldset">
                                    <h2 className="classification-form__fieldset-heading">3. Välj besöksfrekvens & tid</h2>
                                    <label className="classification-form__label" htmlFor="frequency">Frekvens (besök/säljcykel)</label>
                                    <Select value={this.getDefaultSelected(classification.classificationFrequencies, 'classificationFrequencyCode')}
                                            onChange={(e) => this.handleChangeSelectBox('classificationFrequencies', 'classificationFrequencyCode', e.currentTarget.value*1)}>
                                        {classification.classificationFrequencies.map(freq => {
                                            return (
                                                <option key={`classificationFrequencyId${freq.classificationFrequencyId}`} value={freq.classificationFrequencyCode}>{freq.classificationFrequencyValue}</option>
                                            );
                                        })}
                                    </Select>
                                    <label className="classification-form__label" htmlFor="time">Tid (timmar/besök)</label>
                                    <Select value={this.getDefaultSelected(classification.classificationVisitingTimes, 'classificationVistingTimeCode')}
                                            onChange={(e) => this.handleChangeSelectBox('classificationVisitingTimes', 'classificationVistingTimeCode', e.currentTarget.value*1)}>
                                        {classification.classificationVisitingTimes.map(time => {
                                            return (
                                                <option key={`classificationVistingTimeId${time.classificationVistingTimeId}`} value={time.classificationVistingTimeCode}>{time.classificationVistingTimeValue}</option>
                                            );
                                        })}
                                    </Select>
                                </fieldset>
                            </div>
                            <div className="classification-form__footer">
                                <div className="classification-form__footer-controls">
                                    <SaveButton type="submit"
                                        isLoading={this.state.isSaving}
                                        isSaved={this.state.isSaved} 
                                        text="Spara klassificering" 
                                        textSaving="Sparar klassificering"
                                        textSaved="Klassificering sparades!" 
                                        modifiers={{
                                            'classification-form__save': true
                                        }}
                                        attr={{
                                            disabled: this.state.isSaving || (classification && !classification.name)
                                        }} />
                                        
                                        {this.props.cancelButton}
                                        
                                        {!this.props.cancelButton &&
                                            <a className="classification-form__cancel" href={`/scenario/${match.params.scenarioId ? match.params.scenarioId : ''}`}>Avbryt</a>
                                        }
                                </div>
                            </div>
                            
                        </form>
                    }
                </div>

                <SpinnerDots />
            </div>
        );
    }
};

export default withAuthProvider(withFetch(withRouter(CreateClassificationForm)));